import { render, staticRenderFns } from "./NinForm.vue?vue&type=template&id=78d76eb9&scoped=true"
import script from "./NinForm.vue?vue&type=script&lang=js"
export * from "./NinForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78d76eb9",
  null
  
)

export default component.exports